"use strict";

function UnkownStoreError(store) {
  this.name = "Unknown store";
  this.message = "Unknown store " + store;
}

UnkownStoreError.prototype = Error.prototype;

module.exports = UnkownStoreError;


/*****************
 ** WEBPACK FOOTER
 ** ./~/marty/dist/node/lib/errors/unknownStore.js
 ** module id = 449
 ** module chunks = 0
 **/